import React, { useState, useEffect } from "react";
import ListadoProducto from "./ListadoProducto";
import BarraParaOrdenar from "./BarraParaOrdenar";
import SeccionIzquierda from "./SeccionIzquierda";
import { productosAPI } from "../../utils/funcionesAPI";
import PropTypes from "prop-types";
import Loader from "../Global/Loader.js";
import { manejadorDeRespuesta } from "../../utils/Tools";
import { ToastContainer } from "react-toastify";
import Breadcrumbs from "./breadcrumbs";
import Titulo from "./titulo";

const Resultados = (props) => {

  const { pasajerosAdultos, match } = props;

  const {
    origen,
    destino,
    fecha,
    idProducto,
    idGrupo,
    nombreGrupo,
    promociones,
    idCharter
  } = match.params;

  const [productosEncontrados, setProductosEncontrados] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [esSoloYSolas, setEsSoloYSolas] = useState(false);

  const traerProductosBuscados = (origen, destino, fecha, pasajeros = []) => {
    // FC: traer prod por orig, des, fecha
    const data = JSON.stringify({
      peticion: "traerProductosBuscados",
      origen,
      destino,
      fecha,
      adultos: pasajeros.length,
      canal: 'WEB'

    });
    setLoaded(false);
    productosAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setLoaded(true);
        setProductosEncontrados(respuesta.data);
      }
    });
  };

  const traerProductosPorGrupo = (origen, idGrupo, pasajeros = []) => {
    if (pasajeros.length === 1) {
      setEsSoloYSolas(true);
      return;
    }
      const data = JSON.stringify({
        peticion: "traerProductosPorGrupo",
        idGrupo,
        origen,
        adultos: pasajeros.length,
        canal: 'WEB'
      });
      productosAPI(data).then((respuesta) => {
        if (manejadorDeRespuesta(props, respuesta)) {
          let valor = false;
          if ((idGrupo === "7" || idGrupo === "14")) {
            valor = true;
            handleAdultosChange(1);
          }
          setProductosEncontrados(respuesta.data);
          setLoaded(true);
          setEsSoloYSolas(valor);
        }
      });
    
  };

  const traerProductosValijaYa = (origen, pasajeros = []) => {
      const data = JSON.stringify({
        peticion: "traerProductosValijaYa",
        origen,
        adultos: pasajeros.length,
        canal: 'WEB'
      });
      productosAPI(data).then((respuesta) => {
        if (manejadorDeRespuesta(props, respuesta)) {
          let productos = respuesta.data;
          for (let i = 0; i < productos.length; i++) {
            if (productos[i].charters.length === 0) {
              productos.splice(i, 1);
            }
          }
          setProductosEncontrados(productos);
          setLoaded(true);
        }
      });
  };

/*   useEffect(() => {

    if (idGrupo === "7" || idGrupo === "14") {
      handleAdultosChange(1);
    }
  }, []); */

  useEffect(() => {

    if (idGrupo) {
      traerProductosPorGrupo(
        origen,
        idGrupo,
        pasajerosAdultos
      );
    } else if (promociones) {
      traerProductosValijaYa(origen, pasajerosAdultos);
    } else {
      traerProductosBuscados(
        origen,
        destino,
        fecha,
        pasajerosAdultos
      );
      props.onLoadEstadoInicial(
        fecha,
        destino,
        origen
      );
    }
  }, [
    origen,
    destino,
    fecha,
    idGrupo,
    promociones,
    pasajerosAdultos
  ]);

  const mostrarNombreDestino = (codigo) => {
    if (props.busqueda.destinos.length === 0) return "";
    const destino = props.busqueda.destinos.find(
      (destino) => destino.idDestino === codigo
    );
    if (!destino) return "Destino no encontrado";

    return destino.descripcion;
  };
/*
  const asociarImagenes = (productos) => {
    let destinosCacheados = CacheDestinos;
    if (destinosCacheados[0].modoCache) {
      productos.map((unProducto) => {
        let destinoEncontrado = destinosCacheados[1].destinos.find(
          (unDestino) => unDestino.idDestino === unProducto.destino.idDestino
        );
        if (destinoEncontrado) {
          unProducto.destino.imagenes = destinoEncontrado.imagenes.slice();
          //unProducto.destino.whatsapp = destinoEncontrado.whatsapp;
        }
      });
    }
    return true;
  };
*/
  const handleProductoClick = (producto) => {
    props.onProductoClick(producto);
  };

  const handleCharterClick = (charter) => {
    props.onCharterClick(charter);
  };

  const handleOrdenarClick = (e) => {
    let productosEncontradosLocal = productosEncontrados.slice(); //creating copy of object

    if (e.target.name === "menor") {
      productosEncontradosLocal.sort(
        (a, b) =>  {
          if (a.tarifaPorHabitacion || b.tarifaPorHabitacion) return true; 
          a.tarifas[0].tarifaNeta - b.tarifas[0].tarifaNeta
        }
      );
    } else {
      productosEncontradosLocal.sort(
        (a, b) =>  {
          if (a.tarifaPorHabitacion || b.tarifaPorHabitacion) return true; 
          b.tarifas[0].tarifaNeta - a.tarifas[0].tarifaNeta
        }
      );
    }
    setProductosEncontrados(productosEncontradosLocal);
  };

  const handlePosicionarPorTransporte = (idProducto) => {
    document.getElementById(idProducto).scrollIntoView(false);
  }

  //FC eventos del Buscador
  const handleCombosBusquedaChange = (propiedad, valor) => {
    props.onSelectChange(propiedad, valor);
  };

  const handleCombosOrigenBusquedaChange = (origen) => {
    props.onSelectOrigenChange(origen);
  };

  const handleCombosDestinoBusquedaChange = (destino) => {
    props.onSelectDestinoChange(destino);
  };

  const handleAdultosChange = (cantidad) => {
    props.onAdultosChange(cantidad);
  };

  const handleMenoresChange = (fecha) => {
    props.onMenoresChange(fecha);
  };

  const handleEdadChange = (clave, valor) => {
    props.onEdadChange(clave, valor);
  };


  //const destino = this.props.match.params.destino;
  //const fecha = this.props.match.params.fecha;
  //const idProducto = this.props.match.params.idProducto;
  //asociarImagenes(productosEncontrados);
  //console.log(destinosJSON);

  return (
    <section id="main-content" className="main">
      <div className="container-fluid">
        <Breadcrumbs
          nombreDestino={mostrarNombreDestino(destino)}
          destino={destino}
        />
        <Titulo
          nombreDestino={mostrarNombreDestino(destino)}
          destino={destino}
          idGrupo={idGrupo}
          nombreGrupo={nombreGrupo}
          promociones={promociones}
          cantidadProductos={productosEncontrados.length}
          origen={origen}
          fecha={fecha}
        />

        <div className="row">
          <SeccionIzquierda
            busqueda={props.busqueda}
            onSelectChange={handleCombosBusquedaChange}
            onSelectOrigenChange={handleCombosOrigenBusquedaChange}
            onSelectDestinoChange={handleCombosDestinoBusquedaChange}
            onAdultosChange={handleAdultosChange}
            onMenoresChange={handleMenoresChange}
            onEdadChange={handleEdadChange}
            solosYsolas={esSoloYSolas}
          />
          <article className="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-12 show-results">
            <BarraParaOrdenar
              onClickOrdenar={handleOrdenarClick}
              posicionarEn={handlePosicionarPorTransporte}
              solosYsolas={esSoloYSolas}
              destino={destino}
              productos={productosEncontrados}
            />
            <Loader
              loaded={loaded}
              mensaje="Buscando Paquetes, aguarde unos instantes..."
            />
            {productosEncontrados.length === 0 && loaded && (
              <div className="loader row result">
                <h3>No se han encontrado Paquetes en este mes. Por favor pruebe buscando otro periodo.</h3>
              </div>
            )}
            {loaded && (
              <ListadoProducto
                origen={origen}
                destino={destino}
                fecha={fecha}
                productos={productosEncontrados}
                idProducto={idProducto}
                onProductoClick={handleProductoClick}
                onCharterClick={handleCharterClick}
                idCharterDeURL={idCharter}
                solosYsolas={esSoloYSolas}
                pasajerosAdultos={pasajerosAdultos}
              />
            )}
          </article>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default Resultados;

Resultados.propTypes = {
  onProductoClick: PropTypes.func.isRequired,
  onCharterClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Resultados/index.js